import { render, staticRenderFns } from "./GroupAuth.vue?vue&type=template&id=47a64f43&"
import script from "./GroupAuth.vue?vue&type=script&lang=ts&"
export * from "./GroupAuth.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports